<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <div class="row">
            <div class="col d-flex align-items-center">
              <div>
                <h6 class="header-pretitle">Overview</h6>
                <h1 class="header-title">Programs</h1>
              </div>
            </div>
            <div class="col-auto d-flex align-items-center">
              <button
                v-if="$userIsAdmin"
                type="button"
                class="btn btn-sm btn-outline-info"
                data-toggle="modal"
                data-target=".modal-manage-capabilities">
                  <font-awesome :icon="['far', 'cogs']"/> Manage Capabilities
              </button>
            </div>
            <div class="col-auto d-flex align-items-center">
              <router-link v-if="$userIsAdmin" :to="{ name: 'programs.create' }" class="btn btn-sm btn-outline-primary">
                <font-awesome :icon="['far', 'plus']" class="mr-2"/> Add Program
              </router-link>
            </div>
          </div><!-- /.row -->
        </div><!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">

      <h3>Filter</h3>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group">
            <label class="control-label">Program Name</label>
            <input v-model="filters.search" type="text" class="form-control" />
          </div><!-- /.form-group -->
        </div>

        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group">
              <label class="control-label">Status</label>
              <multiselect
              v-model="statusSelected"
              label="text"
              :options="statusOptions"
              :allow-empty="false"
              :searchable="false"
              :show-labels="false"/>
          </div><!-- /.form-group -->
        </div>
      </div><!-- /.row -->

      <div class="decorative-divider mt-0"></div>

      <div class="card">
        <loading-spinner v-if="fetching"/>

        <no-results v-else-if="haveNoPrograms">
          No programs found.
        </no-results>

        <ul v-else class="list-data">
          <programs-list-item
            v-for="program in programs"
            :key="program.id"
            :program="program"/>
        </ul><!-- /.list-data -->
      </div><!-- /.card -->
    </div><!-- /.container-fluid -->
    <portal to="modals">
      <manage-capabilities-modal />
    </portal>
  </div>
</template>

<script>
import { programComputed, programMethods } from 'vx/helpers'
import ProgramsListItem from './ProgramsListItem'
import ManageCapabilitiesModal from './ManageCapabilitiesModal'
import { appliesFilters } from 'mixins'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [appliesFilters],

  components: {
    ProgramsListItem,
    ManageCapabilitiesModal,
    Multiselect
  },

  data () {
    return {
      fetching: false,
      filters: {
        search: null,
        status: 'active'
      },
      statusOptions: [
        {
          value: 'all',
          text: 'Show All'
        },
        {
          value: 'active',
          text: 'Active'
        },
        {
          value: 'complete',
          text: 'Complete'
        },
        {
          value: 'scheduled',
          text: 'Scheduled'
        },
        {
          value: 'draft',
          text: 'Draft'
        },
        {
          value: 'archived',
          text: 'Archived'
        }
      ]
    }
  },

  computed: {
    ...programComputed,

    haveNoPrograms () {
      return this.programs.length === 0
    },

    statusSelected: {
      get () {
        return this.statusOptions.find(option => option.value === this.filters.status)
      },

      set (option) {
        this.filters.status = option.value
      }
    }
  },

  watch: {
    queryParams: {
      async handler (params) {
        this.fetching = true

        await this.getPrograms(params)

        this.fetching = false

        this.$nextTick(() => {
          if (this.$refs.lazy) {
            this.$refs.lazy.$emit('reset')
          }
        })
      },
      immediate: true
    }
  },

  beforeDestroy () {
    this.resetPrograms()
  },

  methods: {
    ...programMethods
  }
}
</script>
